<div class="loading-spinner">
  <mat-spinner [diameter]="diameter" [strokeWidth]="strokeWidth"></mat-spinner>
</div>